/* Created by Interactive 63 - https://interactive63.com */
/**
 * A small channel between the places that start text editing (the stage, the menu and the
 * shortcut) and the Inspector, which owns the text field. It keeps the stage from reaching into
 * another panel's markup.
 */
type Listener = () => void;

const listeners = new Set<Listener>();

/** Asks whoever shows the selected text's content field to focus it. */
export function requestTextEditing(): void {
  for (const listener of listeners) listener();
}

/** Listens for requests to edit the selected text. Returns a function that stops listening. */
export function onTextEditingRequest(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
